import React, { useEffect, useState } from "react";
import { useParams, useNavigate, useLocation } from "react-router-dom";
import { Box, Typography, Button, Paper, CircularProgress } from "@mui/material";
import CheckCircleIcon from "@mui/icons-material/CheckCircle";
import CancelIcon from "@mui/icons-material/Cancel";
import jsPDF from "jspdf";

import autoTable from 'jspdf-autotable';
import '../assets/Roboto-Bold'

(jsPDF as any).API.events.push(["addFonts", function (this: typeof jsPDF.prototype) {
  this.addFont("Roboto-Bold.ttf", "RobotoBold", "normal");
}]);

const PaymentResultPage: React.FC = () => {
  const navigate = useNavigate();
  const location = useLocation();
  const { status } = useParams();
  const queryParams = new URLSearchParams(location.search);
  const errorMessage = queryParams.get("em");
  const successMessage = queryParams.get("sr");
  const paymentId = queryParams.get("Id");

  const isSuccess = status === "success";

  const [receiptData, setReceiptData] = useState<any>(null);
  const [loading, setLoading] = useState(false);

  useEffect(() => {
    if (isSuccess && paymentId) {
      setLoading(true);

      const formData = new FormData();
      formData.append("Id", paymentId);

      fetch("https://pay.duyu.alter.net.tr/api/Receipt", {
        method: "POST",
        body: formData,
      })
        .then((res) => res.json())
        .then((data) => setReceiptData(data.result))
        .catch((err) => console.error("Rapor alınamadı:", err))
        .finally(() => setLoading(false));
    }
  }, [isSuccess, paymentId]);

  const handleDownloadPDF = () => {
    if (!receiptData) return;
  
    const doc = new jsPDF({
      format: "a5",
      orientation: "landscape",
    });

      // 🧾 Başlık: MAKBUZ
  doc.setFontSize(16);
  doc.setFont("RobotoBold", "normal");
  doc.setTextColor(0);
  doc.text("MAKBUZ", doc.internal.pageSize.getWidth() / 2, 8, { align: "center" });
  
    doc.setFont("RobotoBold", "normal");
  
    const formattedDate = new Date(receiptData.islemTarihi).toLocaleString("tr-TR", {
      day: "2-digit",
      month: "2-digit",
      year: "numeric",
      hour: "2-digit",
      minute: "2-digit",
      second: "2-digit",
    });
  
    const firmaAdi = receiptData.firmaAdi;
    const tutar = `${Number(receiptData.tutar).toLocaleString("tr-TR")} ₺`;
  
    // 🟩 Başlık kutusu
    doc.setFontSize(10);
    doc.setFillColor(220, 255, 220);
    doc.rect(10, 10, 190, 20, "F");
    doc.setTextColor(0, 100, 0);
    doc.text(`SAYIN ${firmaAdi}`, 15, 18);
    doc.setFontSize(10);
    doc.setTextColor(50);
    doc.text("Yapmış olduğunuz ödeme için teşekkür ederiz. İşlem bilgileriniz aşağıda bulunmaktadır.", 15, 26);
  
    // 📄 İşlem Bilgileri
    doc.setFontSize(12);
    doc.setTextColor(0);
    doc.setFont("RobotoBold", "normal");
    doc.text("İşlem Bilgileri", 15, 40);
  
    autoTable(doc, {
      startY: 45,
      theme: "grid",
      styles: {
        font: "RobotoBold",
        fontSize: 9,
        cellPadding: 3,
      },
      headStyles: {
        fillColor: [242, 242, 242],
        textColor: 0,
        fontStyle: "bold",
      },
      body: [
        ["Firma Adı", firmaAdi],
        ["İşlem Tarihi", formattedDate],
      ],
      margin: { left: 15, right: 15 },
      columnStyles: {
        0: { cellWidth: 50 },
        1: { cellWidth: 120 },
      },
    });
  
    // 💸 Ödeme Bilgileri
    const finalY = (doc as any).lastAutoTable?.finalY || 60;
    doc.setFont("RobotoBold", "normal");
    doc.text("Ödeme Bilgileri", 15, finalY + 10);
  
    autoTable(doc, {
      startY: finalY + 15,
      theme: "grid",
      styles: {
        font: "RobotoBold",
        fontSize: 9,
        cellPadding: 3,
      },
      headStyles: {
        fillColor: [242, 242, 242],
        textColor: 0,
        fontStyle: "bold",
      },
      body: [
        ["Ödeme Tutarı", tutar],
        ["Taksit Sayısı", `${receiptData.taksitSayisi}`],
        ["Sanal Pos", receiptData.sanalPos],
      ],
      margin: { left: 15, right: 15 },
      columnStyles: {
        0: { cellWidth: 50 },
        1: { cellWidth: 120 },
      },
    });
  
    const pdfUrl = doc.output("bloburl");
    window.open(pdfUrl, "_blank");
  };
  
  
  
  

  return (
    <Box
      sx={{
        height: "100vh",
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
        background: "#fff",
      }}
    >
      <Paper
        elevation={4}
        sx={{
          p: 4,
          display: "flex",
          flexDirection: "column",
          alignItems: "center",
          gap: 2,
          borderRadius: 3,
        }}
      >
        {isSuccess ? (
          <>
            <CheckCircleIcon sx={{ fontSize: 80, color: "green" }} />
            <Typography variant="h5" fontWeight="bold" color="green">
              Ödeme Başarılı!
            </Typography>
            <Typography>
              {successMessage || "Teşekkür ederiz. Ödemeniz başarıyla tamamlandı."}
            </Typography>
          </>
        ) : (
          <>
            <CancelIcon sx={{ fontSize: 80, color: "red" }} />
            <Typography variant="h5" fontWeight="bold" color="red">
              Ödeme Başarısız
            </Typography>
            <Typography>{errorMessage || "Lütfen kart bilgilerinizi kontrol edin ve tekrar deneyin."}</Typography>
          </>
        )}

        <Button
          variant="contained"
          color={isSuccess ? "success" : "error"}
          onClick={() => navigate("/home")}
        >
          Anasayfaya Dön
        </Button>

        {isSuccess && receiptData && (
          <Button variant="outlined" onClick={handleDownloadPDF}>
            Makbuzu Görüntüle
          </Button>
        )}

        {isSuccess && loading && <CircularProgress size={24} />}
      </Paper>
    </Box>
  );
};

export default PaymentResultPage;
